export const TestimonialData = [
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'Klay Harris',
        Clinet:'Client'
    },
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'Mary Lens',
        Clinet:'Client'
    },
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'Klay Harris',
        Clinet:'Client'
    },
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'Anna Chel',
        Clinet:'Client'
    },
]